import { Box, HStack, useTheme, VStack } from 'native-base';
import { Check } from 'lucide-react';

import { Text } from '@pimm/base';
import { getScheduleTypeColor } from '../_helper';
import { TaskLists } from '../types';
import WarningIcon from '../icons/warning';

type KitchenPositionSlotTaskSectionProps = {
  stats: TaskLists;
  showMax: number;
  label: string;
};

const KitchenPositionSlotTaskSection = ({ stats, showMax, label }: KitchenPositionSlotTaskSectionProps) => {
  const { colors } = useTheme();

  return (
    <VStack space={1}>
      <HStack alignItems="center">
        <Text size="sm" fontWeight={600} color="gray.600" lineHeight="xs" flex={1} numberOfLines={1}>
          {label}
        </Text>
        <HStack space={1}>
          {stats.doneToday > 0 && (
            <HStack rounded="sm" px={1} h={4} bg="success.50" alignItems="center" space="2px">
              <Check size={10} color={colors.success[700]} strokeWidth={3} />
              <Text size="xs" fontWeight={700} color="success.700">
                {stats.doneToday}
              </Text>
            </HStack>
          )}
          {stats.overdueCount > 0 && (
            <HStack rounded="sm" px={1} h={4} bg="error.50" alignItems="center" space="2px">
              <WarningIcon size="xs" color={colors.error[700]} />
              <Text size="xs" fontWeight={700} color="error.700">
                {stats.overdueCount}
              </Text>
            </HStack>
          )}
        </HStack>
      </HStack>
      {stats.active.slice(0, showMax).map(task => (
        <HStack key={task.cleaningTaskId} space={1.5} alignItems="center">
          <Box rounded="full" w={2.5} h={2.5} borderWidth={2} borderColor={`${getScheduleTypeColor(task.scheduleType)}.500`} />
          <Text size="sm" fontWeight={500} color={task.isOverdue ? 'error.500' : 'black'} numberOfLines={1} ellipsizeMode="tail" flex={1}>
            {task.title}
          </Text>
        </HStack>
      ))}
    </VStack>
  );
};

export default KitchenPositionSlotTaskSection;
